module.exports = __webpack_public_path__ + "img/Doelstelling.398a0f2f.jpg";